let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("joJy8"), load("aHE9G"), load("kHBkS")]).then(() => parcelRequire('1sMjA'));